import { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import AppContext from "../../contexts/AppContext";
import RoundedBoxInfo from "../RoundedBoxInfo";
import TitleWithPaging from "../TitleWithPaging";
import RectButton from "../ui/button/RectButton";

import "./style.scss";

class OrderBox extends Component {
    static contextType = AppContext;
    state = {
        page: 0,
        plainMode: this.props.plain,
        writeStyle: "pacifico"
    }

    changePage = (value) => {
        console.log(value)
        this.setState({ page: value });
    }

    render() {
        let totalPages = this.props.orders.length;

        let {
            sender,
            recipient,
            count,
            price,
            postage,
            orderID,
            sendDate,
            giftCardPrice,
            insert,
            writingStyle,
            letter,
            image } = this.props.orders[this.state.page];

        return (
            <div className="box order-box">
                <div className="row order-container">
                    <div className="info">
                        <div className="card-image"><img src={image} alt="Card" /></div>
                        <div className="order-infos column">
                            <RoundedBoxInfo>Order ID: {orderID}</RoundedBoxInfo>
                            {this.props.edit ? <RoundedBoxInfo>Upcoming <span className="space">|</span> <Link to="/">Cancel</Link></RoundedBoxInfo> : null}
                            {this.context.testMode ? <RoundedBoxInfo className="test-order">Test Order</RoundedBoxInfo> : null}
                        </div>
                    </div>
                    <div className="general-info column">
                        <TitleWithPaging page={this.state.page} pages={totalPages} onPageChange={this.changePage} />
                        <div className="row details">
                            <div className="row sender-recipient">
                                <div className="sender column">
                                    <span className="strong">Sender</span>
                                    <span>{sender.name}</span>
                                    <span>{sender.address}</span>
                                    <span>{sender.address2}</span>
                                </div>
                                <div className="recipient column">
                                    <span className="strong">Recipient</span>
                                    <span>{recipient.name}</span>
                                    <span>{recipient.address}</span>
                                    <span>{recipient.address2}</span>
                                </div>
                            </div>
                            <div className="checkout row">
                                <div className="card-image"><img src="https://via.placeholder.com/146x189/004AAB" alt="Card" /></div>
                                <div className="labels column">
                                    <span>{count} Cards</span>
                                    <span >Subtotal</span>
                                    <span >Postage</span>
                                    <span className="strong">Total</span>
                                </div>
                                <div className="values column">
                                    <span>${price}</span>
                                    <span>${price * count}</span>
                                    <span>${postage}</span>
                                    <span className="strong">${price * count + postage}</span>
                                </div>
                                <div className="actions column">
                                    {
                                        this.props.edit ?
                                            <>
                                                <RectButton text="EDIT" />
                                                <RectButton text="DELETE" />
                                            </> : <RectButton text="CANCEL" />
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="row letter-details">
                            <div className="letter-container column">
                                <div className={`letter dashed-box ${this.state.plain ? "plain" : this.state.writeStyle}`}>
                                    <div className="message" dangerouslySetInnerHTML={{ __html: letter }}></div>
                                    <div className="signature">
                                        <span className="name right">David Wise</span>
                                        <img className="right" src="https://via.placeholder.com/171x68/004AAB" alt="Signature" />
                                    </div>
                                </div>
                                <div className="actions row lock">
                                    <div className={`uh ${!this.state.plain ? "selected" : ""}`} onClick={() => this.setState({ plain: false })}>Preview Mode</div>
                                    <div className={`uh ${this.state.plain ? "selected" : ""}`} onClick={() => this.setState({ plain: true })}>Plain Text View</div>
                                </div>
                            </div>
                            <div className="other-infos column">
                                <div className="column">
                                    <span className="strong">Writing Style</span>
                                    <span className="write-style">{writingStyle}</span>
                                </div>
                                <div className="column">
                                    <span className="strong">Send Date</span>
                                    <span>{sendDate}</span>
                                </div>
                                <div className="column">
                                    <span className="strong">Gift Card</span>
                                    <span>${giftCardPrice} Starbucks Card</span>
                                </div>
                                <div className="column">
                                    <span className="strong">Insert</span>
                                    <span>{insert}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(OrderBox);